export default "__VITE_ASSET__fec97f0a__"